import React from 'react';
import GenericPrivacyPolicyPage from '../../../components/GenericPrivacyPolicyPage';

const APP_NAME = 'Random Number Generator Pro';
const LAST_UPDATED_DATE = 'May 2025';

// Updated content string: removed "Last Updated" line, Advertisements section, renumbered subsequent sections
const PRIVACY_POLICY_CONTENT = `
This Privacy Policy describes how your information is handled when you use the Random Number Generator Pro application ("App").

1. Information We Collect
We do not collect any Personally Identifiable Information (PII). All random number generation, settings configuration, and history logging are performed and stored locally on your device.

2. Data Storage and Usage
Your settings (like preferred theme, last used inputs) and generation history (up to the last 50 entries) are stored securely using your device's local storage mechanisms. This data is solely for your convenience and app functionality; it is never transmitted to us or any third party.

3. Premium Features
If you subscribe to Premium Features, the purchase process is managed entirely through your device's app store (e.g., Apple App Store, Google Play Store). This is handled securely by the app store provider according to their privacy policies.

4. Data Security
We rely on the security features of your device's operating system and local storage to protect the data stored by the App. However, please be aware that no method of electronic storage is 100% secure, and we cannot guarantee absolute security of data stored locally on your device.

5. Data Retention
The settings and history data stored by the App remain on your device until you clear the app's data through your device settings or uninstall the App.

6. Children's Privacy
This App is not directed to children under the age of 13. We do not knowingly collect any information from children under 13. If you believe we may have inadvertently collected such information, please contact us so we can promptly remove it.

7. Changes to This Privacy Policy
We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. You are advised to review this Privacy Policy periodically for any changes.

8. Contact Us
If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support.rng@codemates.app" style="color:#007bff;text-decoration:none;">support.rng@codemates.app</a>.
`;

function RandomNumberGeneratorPrivacyPolicyPage() {
  return (
    <GenericPrivacyPolicyPage
      appName={APP_NAME}
      lastUpdatedDate={LAST_UPDATED_DATE}
      policyContent={PRIVACY_POLICY_CONTENT}
    />
  );
}

export default RandomNumberGeneratorPrivacyPolicyPage; 